var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.867 477.867",
    style: {
      enableBackground: "new 0 0 477.867 477.867"
    },
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.6 153.6h-85.333c-9.426 0-17.067 7.641-17.067 17.067s7.641 17.067 17.067 17.067H409.6c9.426 0 17.067 7.641 17.067 17.067v221.867c0 9.426-7.641 17.067-17.067 17.067H68.267c-9.426 0-17.067-7.641-17.067-17.067V204.8c0-9.426 7.641-17.067 17.067-17.067H153.6c9.426 0 17.067-7.641 17.067-17.067S163.026 153.6 153.6 153.6H68.267c-28.277 0-51.2 22.923-51.2 51.2v221.867c0 28.277 22.923 51.2 51.2 51.2H409.6c28.277 0 51.2-22.923 51.2-51.2V204.8c0-28.277-22.923-51.2-51.2-51.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.947 243.934c-6.614-6.387-17.099-6.387-23.712 0L256 300.134V17.067C256 7.641 248.359 0 238.933 0s-17.067 7.641-17.067 17.067v283.068l-56.201-56.201c-6.78-6.548-17.584-6.361-24.132.419-6.388 6.614-6.388 17.1 0 23.713l85.333 85.333c6.657 6.673 17.463 6.687 24.136.03l.031-.03 85.333-85.333c6.549-6.78 6.361-17.584-.419-24.132z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.67cc5cb2.svg";
export { ForwardRef as ReactComponent };